export default "__VITE_ASSET__9b8266f3__"